import React from 'react';

export const MentionLoader: React.FC = React.memo(() => {
    return <React.Fragment></React.Fragment>;
});
